module.exports = "https://health.dajiuxing.com.cn/img/assets/serviceImg/service/5d9b101dff0154d0575f9c6089a1f56c23cd1e5e7203-FPxWES_fw1200_1@2x.png"


//////////////////
// WEBPACK FOOTER
// ./build/cdn-img-stub.js?path=assets%2FserviceImg%2Fservice%2F5d9b101dff0154d0575f9c6089a1f56c23cd1e5e7203-FPxWES_fw1200_1%402x.png
// module id = 5VA5
// module chunks = 93